import React, { FunctionComponent, useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import LicenseInfiniteList from './LicenseInfiniteList';
import LicenseFilters from './LicenseFilters';
import {
    ApplicationList,
    LicenseListFiltersType,
    LicenseTypeListType,
    LicenseColumnConfigurationType,
    PaginationAndLoadingData,
} from '../../store/modules/application/types';
import Loader from '../../components/Loader';
import Header from '../../components/PageHeader/Header';
import Title from '../../components/PageHeader/Title';

type LicenseProps = {
    getApplicationList: Function;
    applicationList: ApplicationList;
    isLoading: boolean;
    isFilteredLoading: boolean;
    listFilters: LicenseListFiltersType;
    listFiltersRefresher: string;
    changeLicenseFilters: Function;
    applyFilters: Function;
    exportLicenses: Function;
    getLicenseTypes: Function;
    setError: Function;
    licenseTypes: LicenseTypeListType;
    loadMore: boolean;
    licensesCount: number;
    getPersonTypes: Function;
    tableColumns?: LicenseColumnConfigurationType[];
    setLicenseColumnSort: Function;
    licensesSort: { orderBy: 'DESC' | 'ASC'; orderCol: string };
};

const License: FunctionComponent<LicenseProps> = (props) => {
    const [pageNumber, setPageNumber] = useState<number>(0);
    const DEFAULT_SORT_ORDER = 'DESC';
    // TODO: Make default-sort column configurable
    const DEFAULT_SORT_COL = 'applications[0].receivedDate';

    const numberOfRows = 50;

    const {
        getApplicationList,
        isFilteredLoading,
        isLoading,
        listFilters,
        applicationList,
        changeLicenseFilters,
        applyFilters,
        exportLicenses,
        listFiltersRefresher,
        getLicenseTypes,
        licenseTypes,
        setError,
        loadMore,
        getPersonTypes,
        licensesCount,
        tableColumns,
        setLicenseColumnSort,
        licensesSort,
    } = props;

    const [orderBy, setOrderBy] = useState<'DESC' | 'ASC'>(
        licensesSort?.orderBy ? licensesSort.orderBy : DEFAULT_SORT_ORDER,
    );
    const [orderCol, setOrderCol] = useState<string>(licensesSort?.orderCol ? licensesSort.orderCol : DEFAULT_SORT_COL);
    useEffect(() => {
        getLicenseTypes();
        getPersonTypes();
        if (!checkIsLicenseFiltersApplied()) {
            getApplicationList({
                pageNumber,
                numberOfRows,
                status: true,
                orderBy,
                orderCol,
                done: () => {},
            });
        } else {
            applyFilters(listFilters, {
                pageNumber: pageNumber,
                numberOfRows,
                status: true,
                orderBy,
                orderCol,
                done: () => {},
            });
        }
        // eslint-disable-next-line
    }, []);

    const checkIsLicenseFiltersApplied = () => {
        return (
            !!listFilters.licenseType.length ||
            !!listFilters.licenseStatus.length ||
            !!listFilters.toDate.length ||
            !!listFilters.fromDate.length
        );
    };

    const handleApplyFilters = (data: LicenseListFiltersType, paginationData: PaginationAndLoadingData) => {
        setLicenseColumnSort(paginationData.orderBy, paginationData.orderCol);
        applyFilters(data, paginationData);
    };
    if (isLoading && applicationList === undefined) {
        return <Loader />;
    }
    return (
        <div className="verticalFillContainer">
            <Header>
                <Grid container md={2} lg={2} direction="row" alignItems="center">
                    <Title titleText="Licenses" />
                </Grid>
                <Grid item md={10} lg={10}>
                    <LicenseFilters
                        checkIsLicenseFiltersApplied={checkIsLicenseFiltersApplied}
                        numberOfRows={numberOfRows}
                        setPageNumber={setPageNumber}
                        listFiltersRefresher={listFiltersRefresher}
                        listFilters={listFilters}
                        changeLicenseFilters={changeLicenseFilters}
                        applyFilters={handleApplyFilters}
                        licenseTypes={licenseTypes}
                        orderBy={orderBy}
                        orderCol={orderCol}
                        DEFAULT_SORT_ORDER={DEFAULT_SORT_ORDER}
                        DEFAULT_SORT_COL={DEFAULT_SORT_COL}
                        setOrderBy={setOrderBy}
                        setOrderCol={setOrderCol}
                        licensesSort={licensesSort}
                    />
                </Grid>
            </Header>
            <div className="verticalFillContent">
                <LicenseInfiniteList
                    getApplicationList={getApplicationList}
                    applicationList={applicationList}
                    isLoading={isLoading}
                    isFilteredLoading={isFilteredLoading}
                    pageNumber={pageNumber}
                    numberOfRows={numberOfRows}
                    setPageNumber={setPageNumber}
                    loadMore={loadMore}
                    listFilters={listFilters}
                    applyFilters={handleApplyFilters}
                    checkIsLicenseFiltersApplied={checkIsLicenseFiltersApplied}
                    licensesCount={licensesCount}
                    orderBy={orderBy}
                    orderCol={orderCol}
                    setOrderBy={setOrderBy}
                    setOrderCol={setOrderCol}
                    setError={setError}
                    exportLicenses={exportLicenses}
                    columnsConfiguration={tableColumns}
                    setLicenseColumnSort={setLicenseColumnSort}
                />
            </div>
        </div>
    );
};

export default License;
